import { SET_SELECTION } from '../../../../../../../../../../constants/selectionOpts';
import chipIntro from './chipIntro';

const expertTipsIntro = ({ length, operationsArray, props, editorRef }) => {
  if (!editorRef) return;

  /**
   * Expert tips pop up intro
   */
  if (length === 1 && operationsArray[0].type === SET_SELECTION) {
    const {
      inputIntro,
      sectionKey,
      setExpertTips,
      setInputIntro,
      autoPromptExpertTips,
      showExpertTips,
    } = props;
    const { count } = inputIntro;

    /**
     * Select the chip as per the focus
     */
    chipIntro({
      count,
      props,
      editorRef,
      sectionKey,
      inputIntro,
      setInputIntro,
      setExpertTips,
      showExpertTips,
      autoPromptExpertTips,
    });
  }
};

export default expertTipsIntro;
